import React from 'react'
import { Route, IndexRoute } from 'react-router'
import getPath from '../shared/utils/getPath'
import BasePage from './components/BasePage'
import IndexPage from './components/IndexPage'
import NotFoundPage from './components/NotFoundPage'

const routes = (
  <Route
    component={BasePage}
    key="base-routes"
    path={getPath('backend', '/')}
  >
    <IndexRoute component={IndexPage} />
    <Route
      component={NotFoundPage}
      path="*"
    />
  </Route>
)

export default routes



// WEBPACK FOOTER //
// ./src/base/routes.js